// extracted by mini-css-extract-plugin
module.exports = {"topSection":"NotFound_topSection__78fbz","main":"NotFound_main__HnO21","img":"NotFound_img__hk3fx"};